import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

//CREATE ACTION
export const fetchRewardSupplierList = createAsyncThunk("fetchRewardSupplierList", async (values, { rejectWithValue }) => {
	try {
		const params = new URLSearchParams({
			page: values.page,
			limit: values.limit,
			keyword: values.filters?.keyword ?? "",
		});
		const channel = PermissionManager.getItem(USER)?.user?.user_channel[0]?.channel_uuid || "";
		const response = await axiosHttp.get(`${REWARD_BASE_URL}channel/${channel}/supplier?${params}`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

//FETCH SUPPLIERS FOR DROPDOWN FILTER
export const fetchSupplierListForFilter = createAsyncThunk("fetchSupplierListForFilter", async (channelId, { rejectWithValue }) => {
	try {
		const params = new URLSearchParams({
			page: 1,
			limit: 1000, // Get all suppliers for filter dropdown
		});
		const response = await axiosHttp.get(`${REWARD_BASE_URL}channel/${channelId}/supplier?${params}`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardSupplierListSlice = createSlice({
	name: "RewardSupplierListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetRewardSupplierListState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardSupplierList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchRewardSupplierList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchRewardSupplierList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});

		// Extra reducers for supplier filter
		builder.addCase(fetchSupplierListForFilter.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchSupplierListForFilter.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchSupplierListForFilter.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetRewardSupplierListState } = RewardSupplierListSlice.actions;
export default RewardSupplierListSlice.reducer;
